import { AuthenticationService } from '../services/authentication.serivce';
import { RouterExtensionsService } from '../services/router-extensions.service';
import { FeedbackMessageService } from '@shared/services/feedback-message.service';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot, Router } from '@angular/router';
import { Services } from '../../shared/literals/shared.literal';

export function RedeploymentAuthorize(permission: number, service?: Services): CanActivateChildFn { //, organizations: number[]
  return (ars: ActivatedRouteSnapshot, rss: RouterStateSnapshot) => {
    var auth = inject(AuthenticationService);

    if (rss.url == "/AuthUser/Detail/" + auth.getSession()?.userId) {
      return true;
    }

    //Only let the user view the page if they have permissions or if it's by a specific service
    if (auth && auth.canPerformAction(permission) && auth.canPerformActionByService(service)) { 
      return true;
    }

    var feedback = inject(FeedbackMessageService);
    feedback.give({ text: "You do not have permission to view this page!", status: "warning" });

    var res = inject(RouterExtensionsService);
    var currentUrl: string = res.getCurrentUrl();

    var router = inject(Router);
    router.navigate([currentUrl]);
    return false;
  }
}
